import React from 'react';
import { ModalContent } from 'fronton-react';
import { ModalHeader, Typography } from 'common/components';
import {
  cabinetBenefitsModalContent,
  cabinetBenefitsModalText,
  cabinetBenefitsModalTitle,
} from '../../cabinet-benefits-styles';

export const CustomSize = () => (
  <>
    <ModalHeader className={cabinetBenefitsModalTitle} title="Индивидуальные размеры до&nbsp;1&nbsp;мм" />
    <ModalContent className={cabinetBenefitsModalContent}>
      <Typography className={cabinetBenefitsModalText} variant="m" size="body_long">
        Наша компания предлагает возможность создать шкафы, полностью адаптированные под ваши уникальные требования. Мы&nbsp;учитываем все детали, что позволит нам изготовить мебель, идеально вписывающуюся в&nbsp;любое помещение. Мы&nbsp;обеспечиваем идеальную гармонию и&nbsp;функциональность, что делает наши шкафы не&nbsp;только стильными, но&nbsp;и&nbsp;практичными.
      </Typography>
    </ModalContent>
  </>
);
